import { DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import ICompanyBase from "../../../../models/ICompanyBase";
import IIntegration from "../../../../models/IIntegration";
import { FormErrors } from "../../../forms/FormErrors";
import WithLoadingSpinners from "../../../hoc/WithLoadingSpinner";
import { IntegrationContextProvider } from "../../contexts/IntegrationContext";
import { handleSubmit, newFormErrors, validate } from "../../functions/sharedFunctions";
import { StyledDialog } from "../../style/IntegrationStyledComponents";
import { NewIntegrationDialogActions } from "./NewIntegrationDialogActions";
import NewIntegrationForm from "./NewIntegrationForm";

interface INewIntegrationDialogProps {
  showDialog: boolean;
  onClose: () => void;
  company?: ICompanyBase;
  token: string;
  addPending: Function;
  completePending: Function;
}

export const NewIntegrationDialog = (props: INewIntegrationDialogProps) => {
  const { showDialog, onClose, company, token, addPending, completePending } = props;
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = React.useState<string>("");
  const [formErrors, setFormErrors] = React.useState<FormErrors<IIntegration>>(newFormErrors());
  const [submitError, setSubmitError] = React.useState<string>("");
  const [form, setForm] = React.useState<IIntegration>({
    ID: 0,
    Name: "",
    Company: { ID: 0, Name: "" },
    Status: { ID: 0, Name: "" },
    DataDirection: { ID: 0, Name: "" },
    System: { ID: 0, Name: "" },
    Module: { ID: 0, Name: "" },
    Description: "",
    PublishNotes: "",
    DevelopmentURL: "",
  });

  const submitNewForm = async () => {
    try {
      setLoadingMessage("Creating new Integration. Page will refresh on success.");
      setIsSubmitting(true);
      setSubmitError("");
      setFormErrors(newFormErrors());
      validate(form, setFormErrors);

      let resp = await handleSubmit({
        form,
        token,
        company,
        addPending,
        completePending,
        setFormErrors,
        setIntegrationErrors: () => {},
        setAllowEdit: () => {},
      });

      if (!resp) {
        throw new Error("An error occurred while creating the Integration. Please submit a service call if you continue to see this error.");
      }

      window.location.reload();
    } catch (err) {
      setSubmitError((err as Error).message);
      setIsSubmitting(false);
    }
  };

  React.useEffect(() => {
    const setCompanyInfo = () => {
      if (company && company.ID && company.Name !== "") {
        let newForm: IIntegration = {
          ...form,
          Company: {
            ID: company.ID,
            Name: company.Name,
          },
        };

        setForm(newForm);
      }
    };

    setCompanyInfo();
  }, []);

  return (
    <IntegrationContextProvider companyId={company ? company.ID : 0} token={token} integrationId={0}>
      <StyledDialog
        open={showDialog}
        onClose={onClose}
        scroll="body"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">Add New Integration</DialogTitle>
        <DialogContent style={{ overflow: "visible", maxHeight: "none", paddingBottom: 0 }}>
          <WithLoadingSpinners isLoading={isSubmitting} message={loadingMessage}>
            <NewIntegrationForm form={form} setForm={setForm} formErrors={formErrors} submitError={submitError} />
          </WithLoadingSpinners>
        </DialogContent>
        {!isSubmitting && <NewIntegrationDialogActions submitNewForm={submitNewForm} onClose={onClose} />}
      </StyledDialog>
    </IntegrationContextProvider>
  );
};
